import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "../../asstes/styles/privateCouncilHero.scss";
import hero1 from "../../asstes/images/private-council/hero-images/hero-slide1.jpeg";
import hero2 from "../../asstes/images/private-council/hero-images/hero-slide2.jpg";

const slides = [hero1, hero2];

const PrivateCouncilHero = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) =>
                prev === slides.length - 1 ? 0 : prev + 1
            );
        }, 5000);

        return () => clearInterval(interval);
    }, []);
    const navigate = useNavigate();
    return (
        <section className="hero-section">
            <div className="hero-slider">
                {slides.map((slide, index) => (
                    <div
                        key={index}
                        className={`slide ${index === currentSlide ? "active" : ""}`}
                        style={{ backgroundImage: `url(${slide})` }}
                    />
                ))}
            </div>

            <div className="hero-overlay"></div>

            <div className="container hero-content">
                <div className="hero-left">
                    <div className="pc-eyebrow">
                        <span className="pc-eyebrow-line"></span>
                        <p className="pc-eyebrow-text">Convened by <strong>Bhupendra Chaudhary</strong>
                        </p>
                    </div>
                    <div className="hero-content-area">
                        <h1 className="page-title">
                            <span className="fs-secondary">The </span> Private  <span className="fs-secondary">Council </span> 
                        </h1>
                    </div>
                </div>

                <div className="hero-right">
                    <div className="pc-frame-outer">

                        {/* FRAME DECORATIONS */}
                        <div className="pc-frame-deco-2" />
                        <div className="pc-frame-deco" />

                        {/* CORNERS */}
                        <span className="pc-corner tl" />
                        <span className="pc-corner tr" />
                        <span className="pc-corner bl" />
                        <span className="pc-corner br" />

                        {/* IMAGE FRAME */}
                        <div className="pc-image-frame">

                            <img
                                src={slides[currentSlide]}
                                alt="Luxury Council"
                                className="pc-image"
                            />

                            {/* OVERLAYS */}
                            <div className="pc-overlay-vignette" />
                            <div className="pc-overlay-tone" />
                            <div className="pc-scan-lines" />
                            <div className="pc-shimmer-line" />

                            {/* BADGE */}
                            <div className="pc-img-badge">
                                <span className="pc-badge-label">
                                    Private Council
                                </span>

                                <span className="pc-badge-name">
                                    Elite Vision 2026
                                </span>
                            </div>

                            {/* COUNTER */}
                            <div className="pc-counter">
                                0{currentSlide + 1}
                            </div>
                        </div>

                        {/* SIDE TEXT */}
                        <p className="pc-side-text">
                            Strictly Confidential · By Invitation Only
                        </p>

                        {/* DOTS */}
                        <div className="pc-dots">
                            {slides.map((_, index) => (
                                <button
                                    key={index}
                                    className={`pc-dot ${index === currentSlide ? "active" : ""
                                        }`}
                                    onClick={() => setCurrentSlide(index)}
                                />
                            ))}
                        </div>
                    </div>
                    <div className="glass card d-none">
                        <div className="pulse-ring"></div>
                        <img src={slides[currentSlide]} alt="" />
                        <div className="card-content">
                            <h4>INVITATION ONLY</h4>
                            <p>Private Innovation Council 2026</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="slider-dots">
                {slides.map((_, index) => (
                    <span
                        key={index}
                        className={index === currentSlide ? "active" : ""}
                        onClick={() => setCurrentSlide(index)}
                    />
                ))}
            </div>
        </section>
    );
};

export default PrivateCouncilHero;